/** Inbox for static-export contact form mailto fallback (not rendered in HTML). */
export function getContactEmail(): string | undefined {
  const email = process.env.NEXT_PUBLIC_CONTACT_EMAIL?.trim();
  return email || undefined;
}
